import React, { FC, useRef, useState } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { getBizNo, formatBizNo } from 'src/utils/charSet';
import NoResult from 'src/components/molecules/table/NoResult';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = [];
  data.forEach((item: any, idx: number) => {
    const infoData = item.infoData || [];
    infoData.forEach((info: any, i: number) => {
      const setItem = {
        ...item,
        infoData: info,
      };
      viewData.push(setItem);
    });
  });

  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };

  const viewDataType = (item: any) => {
    let typeView = '';
    switch (item) {
      case '10':
        typeView = '특례기부금';
        break;
      case '20':
        typeView = '정치자금기부금';
        break;
      case '40':
        typeView = '일반기부금(종교단체 외)';
        break;
      case '41':
        typeView = '일반기부금(종교단체)';
        break;
      case '42':
        typeView = '우리사주조합기부금';
        break;
      case '43':
        typeView = '고향사랑기부금';
        break;
      // case '50':
      //   typeView = '지정기부금';
      //   break;
      default:
        typeView = '';
        break;
    }
    return typeView;
  };
  return (
    <div className="_table_grid_layout _donation_list_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01 _hd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n0">
              <div className="_cont">대상자</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">기부유형</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">기부처</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">사업자 등록번호</div>
            </div>
            <div className="_col _wd_n1">
              <div className="_cont">건수</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">기부금(국세청)</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">기부금(일반)</div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const infoData = item.infoData || {};
            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n0">
                  <div className="_cont">{item.name}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{viewDataType(infoData.data_type)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{infoData.trade_nm}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{getBizNo(infoData.co_num)}</div>
                </div>
                <div className="_col _wd_n1">
                  <div className="_cont">{addComma(infoData.cnt)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{addComma(infoData.htx_amt)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{addComma(infoData.amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
